<template>
  <div id="quality-filters-app">
      <v-container class="quality-filter-container">
        <v-btn-toggle
            multiple
            v-model="qualityExclusions"
        >
          <v-hover
              v-for="item in items"
              :key="item.value"
              v-model="show[item.value]">
            <v-btn
                class="selection-button"
                :value="item.value"
                :ripple="false"
            >
              <span  :class="item.colorClass" class="quality-btn-icon" v-if="!qualityExclusions.includes(item.value)"><i :class="item.icon" name="item.value"></i></span>
              <span  :class="item.colorClass" class="quality-btn-icon" v-if="qualityExclusions.includes(item.value)"><i :class="item.disabledIcon" name="item.value"></i></span>
              <span  :class="item.colorClass" class="quality-btn-label">{{ item.legendTitle }}</span>
              <v-fade-transition>
                <v-hover
                    v-slot="{ hover }"
                >
                  <v-btn
                    :class="{ 'on-hover': hover }"
                    class="only-btn"
                    :value="'Only ' +item.title"
                    v-show="show[item.value]"
                    :color="item.color"
                    dark
                    x-small
                    absolute
                    tile
                    elevation=0
                    :ripple="false"
                    @click="only(item.value, $event)"
                  >
                    <span class="only-label">ONLY</span>
                  </v-btn>
                </v-hover>
              </v-fade-transition>

            </v-btn>
          </v-hover>
          <v-hover
              key="Custom"
              v-model="show['Custom']">
            <v-btn
                class="selection-button"
                value="Custom"
                :ripple="false"
            >
              <span class="semantic-custom quality-btn-icon" :class="hasCustomMetrics ? 'svg-custom-box' : ''">
                <i v-if="!hasCustomMetrics" class="fas fa-tools"></i>
                <i v-if="hasCustomMetrics" class="fas fa-plus float-left-plus"></i>
                <svg v-if="hasCustomMetrics && !qualityExclusions.includes('Custom')"  class="custom-metrics-svg svg-custom-offset" width="16" height="16">
                  <circle class="custom-metrics-circle" cx="8" cy="8" r="8"></circle>
                  <text class="custom-metrics-text" x="50%" y="50%" dy="0.33em">{{ customMetricsLength }}</text>
                </svg>
                <svg v-if="hasCustomMetrics && qualityExclusions.includes('Custom')"  class="custom-metrics-svg svg-custom-offset" width="16" height="16">
                  <circle class="custom-metrics-circle-outline" cx="8" cy="8" r="7"></circle>
                  <text class="custom-metrics-text-normal" x="50%" y="50%" dy="0.33em">{{ customMetricsLength }}</text>
                </svg>
              </span>
              <span class="semantic-custom quality-btn-label">{{ customTitle }}</span>
              <v-fade-transition>
                <v-hover
                    v-slot="{ hover }"
                >
                  <v-btn
                      :class="{ 'on-hover': hover }"
                    class="only-btn"
                    value="Edit Custom"
                    v-show="show['Custom']"
                    color="#8085E9"
                    dark
                    x-small
                    absolute
                    tile
                    elevation=0
                    :ripple="false"
                    @click="only('Custom', $event)"
                  >
                    EDIT
                  </v-btn>
                </v-hover>
              </v-fade-transition>

            </v-btn>
          </v-hover>
        </v-btn-toggle>


        <modal
          class="custom-metrics-modal"
          v-if="showCustomModal"
          header-title="Custom Call Quality Settings"
          @close="showCustomModal = false"
          @cancel="showCustomModal = false"
          :outsideClickWhitelist="modalOutsideClickWhitelist"
        >
          <div slot="body">
            <table class="metric-tag-table">
              <tr>
                <td class="mtt-instructions-td">
                </td>
                <td colspan="8" class="mtt-instructions-td">
                  <span v-if="!showReset" class="mtt-instructions">Create from scratch, or try a <span class="fill-sample" @click="fillBad">Pre-filled Sample</span></span>
                  <span v-if="showReset" class="mtt-instructions" @click="fillReset"><i class="fas fa-undo fill-sample"></i> <span class="fill-sample">Reset to blank</span></span>
                  <div class='img-badge-container-alerts'>
                    <img class="img-badge" src="dist/images/badge-beta-yellow.png" width="34" height="16"/>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <td class="mtt-title-header mtt-main-title" colspan="2"><span class="mtt-header">Audio</span></td>
                <td class="mtt-spacer-col"></td>
                <td class="mtt-title-header mtt-main-title" colspan="2"><span class="mtt-header">Video</span></td>
                <td class="mtt-spacer-col"></td>
                <td class="mtt-title-header mtt-main-title" colspan="2"><span class="mtt-header">Presentation</span></td>
              </tr>
              <tr>
                <td>
                </td>
                <td class="mtt-title-subheader"><span class="mtt-subheader">Send</span></td>
                <td class="mtt-title-subheader"><span class="mtt-subheader">Receive</span></td>
                <td class="mtt-spacer-col"></td>
                <td class="mtt-title-subheader"><span class="mtt-subheader">Send</span></td>
                <td class="mtt-title-subheader"><span class="mtt-subheader">Receive</span></td>
                <td class="mtt-spacer-col"></td>
                <td class="mtt-title-subheader"><span class="mtt-subheader">Send</span></td>
                <td class="mtt-title-subheader"><span class="mtt-subheader">Receive</span></td>
              </tr>
              <tr class="mtt-data-row mtt-data-row-first">
                <td class="mtt-metric">
                  <span class="mtt-header mtt-header-metric">Packet Loss</span>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_audio_packet_loss_rate.operator}}</span>
                    <v-text-field
                        class="small-text-field"
                        outlined
                        dense
                        single-line
                        hide-details
                        v-on:keypress="isShortDecimal($event, customMetrics.tx_audio_packet_loss_rate.value)"
                        v-model.number="customMetrics.tx_audio_packet_loss_rate.value"
                        :rules="[rules.decimal]"
                    ></v-text-field>
                    <span class="field-inline-label2">{{customMetrics.tx_audio_packet_loss_rate.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_audio_packet_loss_rate.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortDecimal($event, customMetrics.rx_audio_packet_loss_rate.value)"
                      v-model.number="customMetrics.rx_audio_packet_loss_rate.value"
                      :rules="[rules.decimal]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_audio_packet_loss_rate.suffix}}</span>
                  </div>
                </td>
                <td class="mtt-spacer-col"></td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_video_packet_loss_rate.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortDecimal($event, customMetrics.tx_video_packet_loss_rate.value)"
                      v-model.number="customMetrics.tx_video_packet_loss_rate.value"
                      :rules="[rules.decimal]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_video_packet_loss_rate.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_video_packet_loss_rate.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortDecimal($event, customMetrics.rx_video_packet_loss_rate.value)"
                      v-model.number="customMetrics.rx_video_packet_loss_rate.value"
                      :rules="[rules.decimal]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_video_packet_loss_rate.suffix}}</span>
                  </div>
                </td>
                <td class="mtt-spacer-col"></td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_presentation_packet_loss_rate.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortDecimal($event, customMetrics.tx_presentation_packet_loss_rate.value)"
                      v-model.number="customMetrics.tx_presentation_packet_loss_rate.value"
                      :rules="[rules.decimal]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_presentation_packet_loss_rate.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_presentation_packet_loss_rate.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortDecimal($event, customMetrics.rx_presentation_packet_loss_rate.value)"
                      v-model.number="customMetrics.rx_presentation_packet_loss_rate.value"
                      :rules="[rules.decimal]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_presentation_packet_loss_rate.suffix}}</span>
                  </div>
                </td>
              </tr>
              <tr class="mtt-data-row mtt-odd-row">
                <td class="mtt-metric">
                  <span class="mtt-header mtt-header-metric">Jitter</span>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_audio_jitter.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.tx_audio_jitter.value)"
                      v-model.number="customMetrics.tx_audio_jitter.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_audio_jitter.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_audio_jitter.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.rx_audio_jitter.value)"
                      v-model.number="customMetrics.rx_audio_jitter.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_audio_jitter.suffix}}</span>
                  </div>
                </td>
                <td class="mtt-spacer-col"></td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_video_jitter.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.tx_video_jitter.value)"
                      v-model.number="customMetrics.tx_video_jitter.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_video_jitter.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_video_jitter.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.rx_video_jitter.value)"
                      v-model.number="customMetrics.rx_video_jitter.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_video_jitter.suffix}}</span>
                  </div>
                </td>
                <td class="mtt-spacer-col"></td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_presentation_jitter.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.tx_presentation_jitter.value)"
                      v-model.number="customMetrics.tx_presentation_jitter.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_presentation_jitter.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_presentation_jitter.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.rx_presentation_jitter.value)"
                      v-model.number="customMetrics.rx_presentation_jitter.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_presentation_jitter.suffix}}</span>
                  </div>
                </td>
              </tr>
              <tr class="mtt-data-row">
                <td class="mtt-metric">
                  <span class="mtt-header mtt-header-metric">Latency</span>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_audio_latency.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.tx_audio_latency.value)"
                      v-model.number="customMetrics.tx_audio_latency.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_audio_latency.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_audio_latency.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.rx_audio_latency.value)"
                      v-model.number="customMetrics.rx_audio_latency.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_audio_latency.suffix}}</span>
                  </div>
                </td>
                <td class="mtt-spacer-col"></td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_video_latency.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.tx_video_latency.value)"
                      v-model.number="customMetrics.tx_video_latency.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_video_latency.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_video_latency.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.rx_video_latency.value)"
                      v-model.number="customMetrics.rx_video_latency.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_video_latency.suffix}}</span>
                  </div>
                </td>
                <td class="mtt-spacer-col"></td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_presentation_latency.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.tx_presentation_latency.value)"
                      v-model.number="customMetrics.tx_presentation_latency.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_presentation_latency.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_presentation_latency.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.rx_presentation_latency.value)"
                      v-model.number="customMetrics.rx_presentation_latency.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_presentation_latency.suffix}}</span>
                  </div>
                </td>
              </tr>
              <tr class="mtt-data-row mtt-odd-row">
                <td class="mtt-metric">
                  <span class="mtt-header mtt-header-metric">Resolution</span>
                </td>
                <td>
                  <span class="mtt-na">N/A</span>
                </td>
                <td>
                  <span class="mtt-na">N/A</span>
                </td>
                <td class="mtt-spacer-col"></td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_video_resolution_y.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.tx_video_resolution_y.value)"
                      v-model.number="customMetrics.tx_video_resolution_y.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_video_resolution_y.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_video_resolution_y.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.rx_video_resolution_y.value)"
                      v-model.number="customMetrics.rx_video_resolution_y.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_video_resolution_y.suffix}}</span>
                  </div>
                </td>
                <td class="mtt-spacer-col"></td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_presentation_resolution_y.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.tx_presentation_resolution_y.value)"
                      v-model.number="customMetrics.tx_presentation_resolution_y.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_presentation_resolution_y.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_presentation_resolution_y.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.rx_presentation_resolution_y.value)"
                      v-model.number="customMetrics.rx_presentation_resolution_y.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_presentation_resolution_y.suffix}}</span>
                  </div>
                </td>
              </tr>
              <tr class="mtt-data-row">
                <td class="mtt-metric">
                  <span class="mtt-header mtt-header-metric">Framerate</span>
                </td>
                <td>
                  <span class="mtt-na">N/A</span>
                </td>
                <td>
                  <span class="mtt-na">N/A</span>
                </td>
                <td class="mtt-spacer-col"></td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_video_frame_rate.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.tx_video_frame_rate.value)"
                      v-model.number="customMetrics.tx_video_frame_rate.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_video_frame_rate.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_video_frame_rate.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.rx_video_frame_rate.value)"
                      v-model.number="customMetrics.rx_video_frame_rate.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_video_frame_rate.suffix}}</span>
                  </div>
                </td>
                <td class="mtt-spacer-col"></td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_presentation_frame_rate.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.tx_presentation_frame_rate.value)"
                      v-model.number="customMetrics.tx_presentation_frame_rate.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_presentation_frame_rate.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_presentation_frame_rate.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.rx_presentation_frame_rate.value)"
                      v-model.number="customMetrics.rx_presentation_frame_rate.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_presentation_frame_rate.suffix}}</span>
                  </div>
                </td>
              </tr>
              <tr class="mtt-data-row mtt-odd-row">
                <td class="mtt-metric">
                  <span class="mtt-header mtt-header-metric">Channel Bitrate</span>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_audio_bitrate.operator}}</span>
                    <v-text-field
                        class="small-text-field"
                        outlined
                        dense
                        single-line
                        hide-details
                        v-on:keypress="isShortInteger($event, customMetrics.tx_audio_bitrate.value)"
                        v-model.number="customMetrics.tx_audio_bitrate.value"
                        :rules="[rules.integer]"
                    ></v-text-field>
                    <span class="field-inline-label2">{{customMetrics.tx_audio_bitrate.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_audio_bitrate.operator}}</span>
                    <v-text-field
                        class="small-text-field"
                        outlined
                        dense
                        single-line
                        hide-details
                        v-on:keypress="isShortInteger($event, customMetrics.rx_audio_bitrate.value)"
                        v-model.number="customMetrics.rx_audio_bitrate.value"
                        :rules="[rules.integer]"
                    ></v-text-field>
                    <span class="field-inline-label2">{{customMetrics.rx_audio_bitrate.suffix}}</span>
                  </div>
                </td>
                <td class="mtt-spacer-col"></td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_video_bitrate.operator}}</span>
                    <v-text-field
                        class="small-text-field"
                        outlined
                        dense
                        single-line
                        hide-details
                        v-on:keypress="isShortInteger($event, customMetrics.tx_video_bitrate.value)"
                        v-model.number="customMetrics.tx_video_bitrate.value"
                        :rules="[rules.integer]"
                    ></v-text-field>
                    <span class="field-inline-label2">{{customMetrics.tx_video_bitrate.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_video_bitrate.operator}}</span>
                    <v-text-field
                        class="small-text-field"
                        outlined
                        dense
                        single-line
                        hide-details
                        v-on:keypress="isShortInteger($event, customMetrics.rx_video_bitrate.value)"
                        v-model.number="customMetrics.rx_video_bitrate.value"
                        :rules="[rules.integer]"
                    ></v-text-field>
                    <span class="field-inline-label2">{{customMetrics.rx_video_bitrate.suffix}}</span>
                  </div>
                </td>
                <td class="mtt-spacer-col"></td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.tx_presentation_bitrate.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.tx_presentation_bitrate.value)"
                      v-model.number="customMetrics.tx_presentation_bitrate.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.tx_presentation_bitrate.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.rx_presentation_bitrate.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortInteger($event, customMetrics.rx_presentation_bitrate.value)"
                      v-model.number="customMetrics.rx_presentation_bitrate.value"
                      :rules="[rules.integer]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.rx_presentation_bitrate.suffix}}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                </td>
                <td class="mtt-spacer-row">
                </td>
                <td class="mtt-spacer-row">
                </td>
              </tr>
              <tr>
                <td>
                </td>
                <td class="mtt-title-header mtt-submain-title">
                  <span class="mtt-header">System</span>
                </td>
                <td class="mtt-title-header mtt-submain-title mtt-apps-broder">
                  <span class="mtt-header">App</span>
                </td>
                <td class="mtt-spacer-col"></td>
                <td rowspan="2" colspan="4" class="mtt-best-practices-td">
                  <span class="mtt-instructions">Setting your own sensitivity levels allows you to precisely customize all<br>available call metrics to be alerted on.  <a :href="brandingService.getSupportUrl('customThresholds')" target='_blank' title='best practices'>Click to learn additional best practices</a></span>
                </td>
              </tr>
              <tr class="mtt-data-row mtt-data-row-first mtt-odd-row">
                <td class="mtt-metric">
                  <span class="mtt-header mtt-header-metric">CPU</span>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.device_system_cpu.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortDecimal($event, customMetrics.device_system_cpu.value)"
                      v-model.number="customMetrics.device_system_cpu.value"
                      :rules="[rules.decimal]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.device_system_cpu.suffix}}</span>
                  </div>
                </td>
                <td>
                  <div flex-nowrap align="center" class="vy-row center-row">
                    <span class="field-inline-label2">{{customMetrics.device_app_cpu.operator}}</span>
                  <v-text-field
                      class="small-text-field"
                      outlined
                      dense
                      single-line
                      hide-details
                      v-on:keypress="isShortDecimal($event, customMetrics.device_app_cpu.value)"
                      v-model.number="customMetrics.device_app_cpu.value"
                      :rules="[rules.decimal]"
                  ></v-text-field>
                  <span class="field-inline-label2">{{customMetrics.device_app_cpu.suffix}}</span>
                  </div>
                </td>
                <td class="mtt-spacer-col"></td>
              </tr>
            </table>
          </div>
          <div slot="footer"></div>
        </modal>
      </v-container>
  </div>
</template>

<script>
  import _ from 'lodash';
  import BrandingService from '../../../../services/branding.service';
  import Modal from "../../../../vueComponents/modal/src/modal.vue";


  const ITEMS = [
      {
        title:'Good',
        value:'Good',
        icon:'fas fa-circle',
        disabledIcon:'far fa-circle',
        colorClass:'semantic-good',
        color:'var(--good-color)',
      },
      {
        title:'Fair',
        value:'Fair',
        icon:'fas fa-circle',
        disabledIcon:'far fa-circle',
        colorClass:'semantic-fair',
        color:'var(--fair-color)',
      },
      {
        title:'Bad',
        value:'Bad',
        icon:'fas fa-circle',
        disabledIcon:'far fa-circle',
        colorClass:'semantic-bad',
        color:'var(--bad-color)',
      },
      {
        title:'Unknown',
        value:'Unknown',
        icon:'fas fa-circle',
        disabledIcon:'far fa-circle',
        colorClass:'semantic-unknown',
        color:'#a7a7a7',
      },
      {
        title:'Custom',
        value:'Custom',
        icon:'fas fa-tools',
        disabledIcon:'fas fa-tools',

        colorClass:'semantic-custom',
        color:'#8085E9',
      },
  ];

  const CALL_METRIC_DIRECTIONS = ['tx', 'rx'];
  const CALL_METRIC_TYPES = ['audio', 'video', 'presentation'];
  const CALL_METRICS = ['bitrate','frame_rate','jitter','latency','packet_loss_rate','resolution_y']

  const DEVICE_METRIC_TYPES = ['device'];
  const DEVICE_METRIC_DIRECTIONS = ['app', 'system'];
  const DEVICE_METRICS = ['cpu']



  export default {
    name: 'quality-filters',
    components: {
      'modal': Modal,
    },
    props: {
      qualityFilters:{
        type: Object,
        default: function () {
          return undefined;
        },
      },
    },
    data: function() {
      return {
        brandingService: BrandingService,
        items: ITEMS.slice(0,ITEMS.length-1),
        qualityExclusions:['Custom'],
        customMetrics: {
          rx_audio_bitrate:                 {value: null, operator: '<',  suffix:'kbps', label: 'Audio (Receive) Channel Bitrate'},
          rx_audio_jitter:                  {value: null, operator: '>', suffix:'ms', label:'Audio (Receive) Jitter'},
          rx_audio_latency:                 {value: null, operator: '>', suffix:'ms', label:'Audio (Receive) Latency'},
          rx_audio_packet_loss_rate:        {value: null, operator: '>', suffix:'%', label:'Audio (Receive) Packet Loss', percent:true},
          rx_video_bitrate:                 {value: null, operator: '<',  suffix:'kbps', label:'Video (Receive) Channel Bitrate'},
          rx_video_frame_rate:              {value: null, operator: '<',  suffix:'fps', label:'Video (Receive) Framerate'},
          rx_video_jitter:                  {value: null, operator: '>', suffix:'ms', label:'Video (Receive) Jitter'},
          rx_video_latency:                 {value: null, operator: '>', suffix:'ms', label:'Video (Receive) Latency'},
          rx_video_packet_loss_rate:        {value: null, operator: '>', suffix:'%', label:'Video (Receive) Packet Loss', percent:true},
          rx_video_resolution_y:            {value: null, operator: '<',  suffix:'p', label:'Video (Receive) Resolution'},
          rx_presentation_bitrate:          {value: null, operator: '<',  suffix:'kbps', label:'Presentation (Receive) Channel Bitrate'},
          rx_presentation_frame_rate:       {value: null, operator: '<',  suffix:'fps', label:'Presentation (Receive) Framerate'},
          rx_presentation_jitter:           {value: null, operator: '>', suffix:'ms', label:'Presentation (Receive) Jitter'},
          rx_presentation_latency:          {value: null, operator: '>', suffix:'ms', label:'Presentation (Receive) Latency'},
          rx_presentation_packet_loss_rate: {value: null, operator: '>', suffix:'%', label:'Presentation (Receive) Packet Loss', percent:true},
          rx_presentation_resolution_y:     {value: null, operator: '<',  suffix:'p', label:'Presentation (Receive) Resolution'},
          tx_audio_bitrate:                 {value: null, operator: '<',  suffix:'kbps', label:'Audio (Send) Channel Bitrate'},
          tx_audio_jitter:                  {value: null, operator: '>', suffix:'ms', label:'Audio (Send) Jitter'},
          tx_audio_latency:                 {value: null, operator: '>', suffix:'ms', label:'Audio (Send) Latency'},
          tx_audio_packet_loss_rate:        {value: null, operator: '>', suffix:'%', label:'Audio (Send) Packet Loss', percent:true},
          tx_video_bitrate:                 {value: null, operator: '<',  suffix:'kbps', label:'Video (Send) Channel Bitrate'},
          tx_video_frame_rate:              {value: null, operator: '<',  suffix:'fps', label:'Video (Send) Framerate'},
          tx_video_jitter:                  {value: null, operator: '>', suffix:'ms', label:'Video (Send) Jitter'},
          tx_video_latency:                 {value: null, operator: '>', suffix:'ms', label:'Video (Send) Latency'},
          tx_video_packet_loss_rate:        {value: null, operator: '>', suffix:'%', label:'Video (Send) Packet Loss', percent:true},
          tx_video_resolution_y:            {value: null, operator: '<',  suffix:'p', label:'Video (Send) Resolution'},
          tx_presentation_bitrate:          {value: null, operator: '<',  suffix:'kbps', label:'Presentation (Send) Channel Bitrate'},
          tx_presentation_frame_rate:       {value: null, operator: '<',  suffix:'fps', label:'Presentation (Send) Framerate'},
          tx_presentation_jitter:           {value: null, operator: '>', suffix:'ms', label:'Presentation (Send) Jitter'},
          tx_presentation_latency:          {value: null, operator: '>', suffix:'ms', label:'Presentation (Send) Latency'},
          tx_presentation_packet_loss_rate: {value: null, operator: '>', suffix:'%', label:'Presentation (Send) Packet Loss', percent:true},
          tx_presentation_resolution_y:     {value: null, operator: '<',  suffix:'p', label:'Presentation (Send) Resolution'},
          device_app_cpu:                   {value: null, operator: '>', suffix:'%', label:'App CPU'}, // todo 0-100
          device_system_cpu:                {value: null, operator: '>', suffix:'%', label:'System CPU'}, // todo 0-100
        },
        customMetricsLength: 0,
        show:{
          Good:false,
          Fair:false,
          Bad:false,
          Unknown:false,
          Custom:false,
        },
        showCustomModal: false,
        emitFilters: false,
        showReset: false,
        modalOutsideClickWhitelist: ['autocomplete-result', 'addFilterGroup', 'addFilter', 'center-pill', 'fa-plus-circle', 'pill', 'pillbox', 'operator', 'remove-filter', 'fill-sample'],
        rules: {
          required: value => {
            return !!value || 'Required.';
          },
          integer: value => {
            if (value === null) { return true; }
            const pattern = /^[0-9]*$/;
            return pattern.test(value) || 'Invalid number.';
          },
          decimal: value => {
            if (value === null) { return true; }
            const pattern = /^[0-9]*\.?[0-9]*$/;
            return pattern.test(value) || 'Invalid decimal.';
          },
        },

      };
    },
    computed: {
      filters: function() {
        let self = this;

        function excludeAllQualities() {
          let filters = [];
          let notValues = ['Good', 'Fair', 'Bad', 'Unknown'];

          filters.push(
              {
                text: 'Quality not in (' + notValues.join(', ') + ')',
                value: 'tags=out=(' + _.map(notValues, s => '"' + 'quality=' + s.toLowerCase() + '"').join(',') + ')',
                field: 'quality',
                type: 'metric',
                operatorValue: 'tags=out=("|=|")',
                queryVar: _.map(notValues, s => s.toLowerCase()).join(','),
                operator: 'not in'
              }
          );
          return filters;
        }

        if (self.qualityExclusions.length === ITEMS.length) { // all items excluded
          let filters = excludeAllQualities();
          let filterExpression =
              {
                type: 'QualitySCUBA',
                data: {
                  qualityExclusions: self.qualityExclusions,
                  // customMetricValues: _.mapValues(self.customMetrics, 'value'),
                },
                filterGroups: [
                  {
                    filters: filters,
                    operator: 'and'
                  }
                ],
                operator: "and"
              };
          // console.log('SCUBA ', filterExpression);
          return filterExpression;

        } else {
          let values = _.difference(['Good', 'Fair', 'Bad', 'Unknown'], self.qualityExclusions);
          let filterGroups = [];
          let filters = [];
          if (values.length > 0 && values.length < 4) { // at least one quality levels excluded
            filters.push(
                {
                  text: 'Quality in (' + values.join(', ') + ')',
                  value: 'tags=in=(' + _.map(values, s => '"' + 'quality=' + s.toLowerCase() + '"').join(',') + ')',
                  field: 'quality',
                  type: 'metric',
                  operatorValue: 'tags=in=("|=|")',
                  queryVar: _.map(values, s => s.toLowerCase()).join(','),
                  operator: 'in'
                }
            );
          } else if (values.length === 0) { // every quality level excluded
            filters = excludeAllQualities();
          } // else no filter on quality as all levels included

          if (filters.length > 0) {
            filterGroups.push(
                {
                  filters: filters,
                  operator: 'and'
                }
            );
          }




          if (!self.qualityExclusions.includes('Custom')) {
            let customFilters = [];

            _.forOwn(self.customMetrics, function(v, key) {
              if (v.value !== null && v.value !== undefined && v.value !== '') {

                customFilters.push(
                    {
                      text: v.label + ' ' + v.operator + ' ' + v.value + v.suffix,
                      value: 'tags==("' + key + v.operator + (v.percent? v.value / 100 : v.value) + '")',
                      field: key,
                      type: 'metric',
                      operatorValue: 'tags==("|'+v.operator+'|")',
                      queryVar: (v.percentage? v.value / 100 : v.value),
                      operator: v.operator // todo should this be the text based operator?
                    }
                );

              }
            })

            filterGroups.push(
                {
                  filters: customFilters,
                  operator: 'or'
                }
            );

          }

          if (!_.isEmpty(filterGroups)) {
            let filterExpression =
                {
                  type: 'QualitySCUBA',
                  data: {
                    qualityExclusions: self.qualityExclusions,
                    customMetricValues: _.mapValues(self.customMetrics, 'value'),
                  },
                  filterGroups: filterGroups,
                  operator: "and"
                };
            // console.log('SCUBA ', filterExpression);
            return filterExpression;
          }
        }
        // console.log('SCUBA ', 'no filter');
        return null;
      },
      hasCustomMetrics: function() {
        let self = this;
        return self.customMetricsLength > 0;
        // return _.some(_.values(self.customMetrics),v=>v.value !== null && v.value !== undefined);
      },
      customTitle: function() {
        let self = this;
        if (self.hasCustomMetrics) {
          return 'Metrics';
        } else {
          return 'Custom';
        }
      },
    },
    created: function() {
      let self = this;
      self.initializeFromQualityFilters();
    },
    mounted(){
      let self = this;
    },
    methods: {
      initializeFromQualityFilters: function () {
        let self = this;
        if (self.qualityFilters &&
            self.qualityFilters.type &&
            self.qualityFilters.type === 'QualitySCUBA' &&
            self.qualityFilters.data &&
            self.qualityFilters.data.qualityExclusions) {
          self.qualityExclusions = self.qualityFilters.data.qualityExclusions;
        }
        if (self.qualityFilters &&
            self.qualityFilters.type &&
            self.qualityFilters.type === 'QualitySCUBA' &&
            self.qualityFilters.data &&
            self.qualityFilters.data.customMetricValues) {
          _.forOwn(self.qualityFilters.data.customMetricValues,
              (value, key) => self.customMetrics[key].value = value);
        }
      },

      fillBad: function() {
        let self = this;

        _.forOwn(self.customMetrics, m => m.value = null);

        self.customMetrics.tx_audio_packet_loss_rate.value = 2.0;
        self.customMetrics.rx_audio_packet_loss_rate.value = 2.0;
        self.customMetrics.tx_video_packet_loss_rate.value = 3.0;
        self.customMetrics.rx_video_packet_loss_rate.value = 3.0;
        self.customMetrics.tx_presentation_packet_loss_rate.value = 6.0;
        self.customMetrics.rx_presentation_packet_loss_rate.value = 6.0;
        
        self.customMetrics.tx_audio_jitter.value = 200;
        self.customMetrics.rx_audio_jitter.value = 200;
        self.customMetrics.tx_video_jitter.value = 300;
        self.customMetrics.rx_video_jitter.value = 300;
        self.customMetrics.tx_presentation_jitter.value = 750;
        self.customMetrics.rx_presentation_jitter.value = 750;
        
        self.customMetrics.tx_audio_latency.value = 300;
        self.customMetrics.rx_audio_latency.value = 300;
        self.customMetrics.tx_video_latency.value = 400;
        self.customMetrics.rx_video_latency.value = 400;
        self.customMetrics.tx_presentation_latency.value = 1000;
        self.customMetrics.rx_presentation_latency.value = 1000;
        self.showReset = true;

      },

      fillReset: function() {
        let self = this;
        _.forOwn(self.customMetrics, m => m.value = null);
        self.showReset = false;
      },

      only: function (quality, event) {
        let self = this;
        if (event) {
          event.stopPropagation();
          // ginormous hack to prevent only button from being part of the button toggle group
          if (event.currentTarget && event.currentTarget.__vue__ && event.currentTarget.__vue__.btnToggle) {
            delete event.currentTarget.__vue__.btnToggle;
          }
        }
        if (quality === 'Custom') { // ensure Custom is not excluded
          // open dialog and enter in custom values

          self.showCustomModal = true;

          self.qualityExclusions = _.difference(self.qualityExclusions, ['Custom']);
        } else { // exclude everything but the 'only' quality
          self.qualityExclusions = _.difference( _.map(ITEMS,'value'), [quality]);
        }
      },
      isShortInteger: function(evt, current) {
        if ((''+current).length > 4) {
          evt.preventDefault();
        } else {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
            evt.preventDefault();
          } else {
            return true;
          }
        }
      },
      isShortDecimal: function(evt, current) {
        let currentStr = evt.currentTarget.value;
        if (currentStr.length > 4) {
          evt.preventDefault();
        } else {
          evt = (evt) ? evt : window.event;
          let hasDot = currentStr && currentStr.indexOf('.') > -1;
          let charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((hasDot && (charCode > 31 && (charCode < 48 || charCode > 57))) ||
              (!hasDot && (charCode > 31 && ((charCode < 46 || charCode === 47) || charCode > 57)))) {
            evt.preventDefault();
          } else {
            return true;
          }
        }
      },
    },
    watch: {
      qualityFilters: {
        deep: true,
        handler: function(qf) {
          let self = this;

          if (qf) {
            self.initializeFromQualityFilters();
          } else {
            self.qualityExclusions = ['Custom'];
            // _.forOwn(self.customMetrics, (value, key) => value.value = '' );
            // self.showReset = false;
          }
        }
      },
      filters: {
        deep: true,
        handler: function(filters) {
          let self = this;

          if (self.showCustomModal) {
            self.emitFilters = true;
          } else {
            self.$emit('quality-filters', filters);
          }
        }
      },
      showCustomModal: {
        deep: true,
        handler: function(show) {
          let self = this;

          if (!show && self.emitFilters) {
            self.emitFilters = false;
            self.$emit('quality-filters', self.filters);
          }
        }
      },
      customMetrics: {
        deep: true,
        handler: function(customMetrics) {
          let self = this;

          self.customMetricsLength = _.filter(_.values(self.customMetrics),v=>v.value !== null && v.value !== undefined && v.value !== '').length;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .quality-filter-container {
    max-width: unset!important;
    margin-left: 0!important;
    margin-right: 0!important;
    padding-top: 0px;
    padding-left: 0px;
    padding-bottom: 10px;


  }

  .quality-btn-label {
    font-size: 8px;
    line-height: 10px;
    font-weight: 800;
    font-family: var(--font-family);
    letter-spacing: unset;
    text-transform: uppercase;
    flex-basis: 100%;
    margin: 0 -8px;
  }
  .quality-btn-icon {
    font-size: 16px;
    line-height: 20px;
  }

  .svg-custom-box {
    width: 18px;
    height: 20px;
  }

  .svg-custom-offset {
    margin-bottom: -2px;
  }

  .v-btn-toggle {
    border-radius: var(--border-radius);
  }

  .v-btn-toggle>.v-btn.v-btn.selection-button:last-child{
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }

  .v-btn-toggle>.v-btn.v-btn.selection-button:first-child {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
    border-left-width: 1px;
  }

  .v-btn-toggle>.v-btn.v-btn.selection-button {
    border-left-width: 0;
  }

  .v-btn-toggle > .v-btn.v-btn.selection-button {
    opacity: 1;
    padding: 0 0px;
  }

  .v-btn:not(.v-btn--round).v-size--default{
    height: 40px;
  }

  .v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
    height: 40px;
    min-width: 47px;
  }

  .v-btn.selection-button:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
    opacity: 0.05;
  }

  .v-btn.selection-button:not(.v-btn--text):not(.v-btn--outlined).v-btn--active span {
    opacity: 0.5;
  }

  .v-btn.selection-button:not(.v-btn--text):not(.v-btn--outlined):hover:before {
    opacity: 0.06;
  }


  .theme--light.v-btn.selection-button:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
    background-color: var(--filter-bg-color);
  }

  .theme--light.v-btn.selection-button:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).v-btn--active {
    color: #FFFFFF
  }

  .add-monitor-text {
    font-size: 14px;
  }

  .field-label {
    font-size: 11px;
    font-weight: 500;
    color: #6D787E;
  }

  .toggle-off-icon {
    color: var(--disabled-color);
  }
  .toggle-on-icon {
    color: var(--primary-btn-bg-color);
  }

  .only-btn {
    top: 31px;
  }

  .only-label {
    font-family: var(--font-family);
    font-weight: bold;
  }

  .on-hover {
    text-decoration: underline;
    text-decoration-thickness: from-font;
  }

  a:hover {
    text-decoration: underline;
  }

  .custom-metrics-svg {
    //margin-top: 1px;
    //margin-bottom: 1px;
    //margin-left: 1px;
    //margin-right: 1px;
  }

  .custom-metrics-circle {
    fill: #8085E9;
  }

  .custom-metrics-circle-outline {
    fill: none;
    stroke: #8085E9;
    stroke-width: 1.5px;
  }

  .custom-metrics-text {
    fill: #FFFFFF;
    font-size: 10px;
    font-weight: 800;
    text-anchor: middle;
  }

  .custom-metrics-text-normal {
    fill: #8085E9;
    font-size: 10px;
    font-weight: 800;
    text-anchor: middle;
  }

  .float-left-plus {
    position: absolute;
    left: 5px;
    top: 5px;
    font-size: 9px;
  }
  .small-text-field {
    max-width: 45px;
  }
  .small-text-field ::v-deep input {
    text-align: center
  }

  .metric-tag-table {
    border-collapse: collapse;

    tr.mtt-data-row td:not(.mtt-spacer-col) {
      border-color: #efefef;
      border-bottom: 1px solid #efefef;
    }
    tr.mtt-data-row-first td:not(.mtt-spacer-col) {
      border-color: #efefef;
      border-top: 1px solid #efefef;
    }

    tr.mtt-odd-row td:not(.mtt-spacer-col) {
      background-color: var(--background-color);
    }



    td {
      text-align: center;
      vertical-align: middle;

      &.mtt-title-header {
        background: var(--active-background) 0% 0% no-repeat padding-box;
        border-radius: 3px 3px 0px 0px;
        opacity: 1;
      }

      &.mtt-main-title {
        height: 45px;
      }

      &.mtt-submain-title {
        height: 35px;
      }

      &.mtt-apps-broder {
        border-left: 1px solid #ffffff;
      }

      &.mtt-spacer-row {
        height: 19px
      }

      &.mtt-spacer-col {
        width: 8px;
        background-color: var(--panel-background);
      }

      &.mtt-metric {
        text-align: left;
      }
      .mtt-header {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: unset;
        white-space: nowrap;
      }
      &.mtt-instructions-td {
        text-align: left;
        padding-bottom:30px;
      }
      &.mtt-best-practices-td {
        text-align: left;
        padding-left:67px;
        vertical-align: bottom;
      }
      .mtt-instructions {
        margin-top: 30px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: unset;
        color: var(--text-color);
        white-space: nowrap;
      }
      .mtt-header-metric {
        margin-left:19px;
        margin-right:19px;
      }
      .mtt-subheader {
        color: #6D787E;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: unset;
      }
      &.mtt-title-subheader {
        background: var(--background-color) 0% 0% no-repeat padding-box;
        opacity: 1;
      }

      .mtt-na {
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: unset;
        font-weight: 500;
      }
    }

    .center-row {
      justify-content: center;
      margin-top: 8px;
      margin-bottom: 7px;
      margin-left: 8px;
      margin-right: 8px;
      flex-wrap: nowrap;
    }

    .fill-sample {
      color: var(--hover-color);
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }

    .img-badge-container-alerts {
      float: right;
    }
  }


</style>
<style lang="scss">
  .quality-filter-container {
    .custom-metrics-modal > .modal-wrapper > .modal-container {
      width: fit-content;
      max-width: 90vw;

      //max-height: calc(100vh - 150px);
      padding: 0;
      border-radius: var(--border-radius);

      > .modal-header {
        .header-title {
          margin-top: 10px;
        }
      }

      > .modal-body {
        margin: 0;
        border: none;
        padding-top: 0px;
        padding-left: 32px;
        padding-right: 33px;
        padding-bottom: 47px;
      }

      > .modal-footer {
        display: none;
      }
    }
    .custom-metrics-modal .autocomplete-result-list {
      padding-left: 0;
    }
  }

  #quality-filters-app .v-btn.only-btn {
    padding: 4px 5px 3px 5px;
    height: 15px;
    min-width: 30px;
    border-radius: 3px;
  }

  #quality-filters-app .v-btn.selection-button:not(.v-btn--flat):not(.v-btn--outlined):not(.v-btn--disabled) .v-btn.only-btn .v-btn__content,
  #quality-filters-app .v-btn.selection-button .v-btn.only-btn .v-btn__content {
    font-size: 8px;
    line-height: 10px;
    font-weight: 700;
    font-family: var(--font-family);
    letter-spacing: unset;
    text-transform: uppercase;
    color: #ffffff;
  }


  #quality-filters-app .v-btn-toggle>.v-btn.v-btn.selection-button {
    border-radius: 0;
  }

  #quality-filters-app .v-btn-toggle>.v-btn.v-btn.selection-button:last-child{
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }

  #quality-filters-app .v-btn-toggle>.v-btn.v-btn.selection-button:first-child {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
  }

  #quality-filters-app .v-btn.selection-button:not(.v-btn--flat):not(.v-btn--outlined):not(.v-btn--disabled) .v-btn__content {
    color: #253035;
    flex-wrap: wrap;
  }

  #quality-filters-app .v-btn.selection-button .v-btn__content {
    font-size: 14px;
    font-weight: 500;
    font-family: var(--font-family);
    letter-spacing: unset;
  }

  #quality-filters-app .v-btn.add-monitor-btn:not(.v-btn--round).v-size--default {
    padding: 0 30px;
  }

  #quality-filters-app .v-tooltip__content.quality-state-tt {
    text-transform: uppercase;
  }

  #quality-filters-app .v-tooltip__content {
    padding: 10px 15px;
    font-weight: bold;
    letter-spacing: unset;
    font-size: 12px;
    line-height: 9px;
    font-family: var(--font-family);
    border-radius: 3px;
  }

  #quality-filters-app .v-tooltip__content:after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 8px;
    border-top-color: inherit;
    border-bottom-color: inherit;
    border-left-color: transparent;
    border-right-color: transparent;
    display: block;
    width: 0;
    z-index: 1;
    top: -8px;
    left: 50%;
    transform: translate(-50%, 0px);
  }

  .v-text-field--outlined fieldset,
  .v-text-field--outlined.v-input--is-focused fieldset {
    border-color: var(--text-color);
  }

  .small-text-field.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding: 0 2px;
  }

  .field-inline-label2 {
    //padding: 0 8px;
    width: 44px;
    line-height: 40px;
    white-space:nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }


</style>
